import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const userMembershipsManifest: FeatureManifest = {
  id: 'user-memberships',
  path: 'user-memberships/*',
  navPath: '/user-memberships',
  label: 'Quản lý hội viên',
  description: 'Quản lý tài khoản hội viên',
  load: () => import('./entry'),
}
